import styled from 'styled-components';

import { StepControlWrapper } from '@domains/auth/ions/cards';

export const StepControlWrapperElement = styled(StepControlWrapper)`
    margin-top: 0;
`;
